export const floatBtn = {
  floatBtnWithdrawl: "提现",
  floatBtnDeposit: "存款",
};
